<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-persona />
    <v-card>
      <v-tabs centered color="primary" dark icons-and-text>
        <v-tabs-slider color="cyan"></v-tabs-slider>
        <v-tab href="#tab-1" v-if="this.$util.permisoRol([32,117])">
          Servidores públicos
          <span class="material-symbols-outlined">
            person
          </span>
        </v-tab>

        <v-tab href="#tab-2" v-if="this.$util.permisoRol([128])">
          Pasantes
          <span class="material-symbols-outlined">
            school
          </span>
        </v-tab>
        <!-- <v-tab href="#tab-3">
          Consultores
          <span class="material-symbols-outlined">
            engineering
          </span>
        </v-tab> -->
        <v-tab-item :value="'tab-1'">
          <v-card flat>
            <v-card-text>
              <h3 class="primary--text">
                <span class="material-symbols-outlined">
                  person
                </span>
                Servidores públicos
              </h3>
              <ListadoPersona :l_id_tipo_persona="[1]" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'tab-2'">
          <v-card flat>
            <v-card-text>
              <h3 class="primary--text">
                <span class="material-symbols-outlined">
                  school
                </span>
                Pasantes
              </h3>
              <ListadoPersona :l_id_tipo_persona="[3]" />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </section>
</template>

<script>
import ListadoPersona from "./components/ListadoPersona.vue";
import CrearActualizarPersona from "./dialogs/CrearActualizarPersona"; // Componente de creación y actualización
export default {
  // Definición de componentes importados
  components: {
    ListadoPersona,
    CrearActualizarPersona
  },
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Variables iniciales del componente
  data() {
    return {};
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {},
  // Métodos y funciones del componente
  methods: {}
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/persona/Index.vue